export default "__VITE_ASSET__t2qSm7l6__"